/* Review-only shortcut: mirror the authoritative builder total; never submit a cart. */
(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-ts-package-bar]').forEach(bar => {
      if (bar.dataset.ready) return;
      const builder = bar.closest('[data-bmw-builder]');
      const total = builder?.querySelector('[data-bmw-total]');
      const summary = builder?.querySelector('[data-bmw-summary]');
      if (!total || !summary) return;
      bar.dataset.ready = 'true';
      const sync = () => { bar.querySelector('[data-ts-package-total]').textContent = total.textContent; };
      sync();
      const totals = new MutationObserver(sync);
      totals.observe(total, { childList: true, characterData: true, subtree: true });
      const visibility = new IntersectionObserver(entries => {
        bar.hidden = entries[0].isIntersecting;
      }, { threshold: 0 });
      visibility.observe(summary);
      bar.hidden = false;
      bar.querySelector('a').addEventListener('click', event => {
        event.preventDefault();
        summary.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        summary.focus({ preventScroll: true });
      });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(bar)) { totals.disconnect(); visibility.disconnect(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
